import hljs from 'highlight.js';

up.compiler('.syntax-highlighted', code => hljs.highlightBlock(code));
